var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "m-box" }, [
        _c("div", { staticClass: "org-tree" }, [
          _c(
            "div",
            { staticClass: "arch-model-sty" },
            [
              _vm.orgSyncType || _vm.currentAuthUser.deptSyncType
                ? _c(
                    "div",
                    { staticStyle: { flex: "1" } },
                    [
                      _c("span", [
                        _c(
                          "span",
                          { staticStyle: { "font-weight": "bolder" } },
                          [_vm._v("组织架构模式：")]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.orgSyncType === 1 ||
                                _vm.currentAuthUser.deptSyncType === 1
                                ? "钉钉架构"
                                : "自行管理"
                            )
                          )
                        ])
                      ]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "切换",
                            placement: "top-start"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "chang-box-sty",
                              on: { click: _vm.synchronous }
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-sort change-icon-sty",
                                staticStyle: { "font-size": "18px" }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.orgSyncType !== 1 || _vm.currentAuthUser.deptSyncType !== 1
                ? _c(
                    "div",
                    [
                      !_vm.isInDingTalk
                        ? _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "80px",
                                "margin-right": "10px"
                              },
                              attrs: {
                                type: "primary",
                                size: "mini",
                                plain: ""
                              },
                              on: { click: _vm.handleJoinApplyVisi }
                            },
                            [_vm._v("成员审核\n            ")]
                          )
                        : _vm._e(),
                      _vm.applyTotal
                        ? _c("span", { staticClass: "apply-sty" }, [
                            _vm._v(_vm._s(_vm.applyTotal))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini", plain: "" },
                  on: { click: _vm.addMember }
                },
                [_vm._v("邀请成员\n          ")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "member-tree-box" },
            [
              _c("el-tree", {
                ref: "memberTree",
                staticClass: "tree-style member-tree",
                attrs: {
                  data: _vm.topGroup,
                  "highlight-current": true,
                  "expand-on-click-node": false,
                  "node-key": "corpGroupId",
                  "default-expand-all": true,
                  "check-strictly": true,
                  props: _vm.defaultProps
                },
                on: { "node-click": _vm.handleNodeClick },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var node = ref.node
                      var data = ref.data
                      return _c(
                        "div",
                        {
                          staticClass: "wrap",
                          attrs: {
                            title:
                              data.groupName +
                              "(" +
                              data.totalNum +
                              "人" +
                              _vm.deptManager(data) +
                              ")"
                          }
                        },
                        [
                          _c("p", { staticClass: "name" }, [
                            _vm._v(
                              _vm._s(
                                data.groupName +
                                  "（" +
                                  data.totalNum +
                                  "人" +
                                  _vm.deptManager(data) +
                                  "）"
                              )
                            )
                          ]),
                          _c(
                            "span",
                            { staticClass: "option-sty" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "添加下级部门",
                                    placement: "top-start"
                                  }
                                },
                                [
                                  _c("img", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.deptEditShow(data),
                                        expression: "deptEditShow(data)"
                                      }
                                    ],
                                    attrs: {
                                      src: "/images/addSub.png",
                                      alt: "",
                                      width: "16"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleClickAddChild(data)
                                      }
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "调整部门",
                                    placement: "top-start"
                                  }
                                },
                                [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.deptEditShow(data) &&
                                          node.level !== 1,
                                        expression:
                                          "deptEditShow(data) && node.level !== 1"
                                      }
                                    ],
                                    staticClass: "el-icon-edit-outline",
                                    on: {
                                      click: function($event) {
                                        return _vm.handleClickEditSelf(data)
                                      }
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "删除部门",
                                    placement: "top-start"
                                  }
                                },
                                [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.deptEditShow(data) &&
                                          node.level !== 1,
                                        expression:
                                          "deptEditShow(data) && node.level !== 1"
                                      }
                                    ],
                                    staticClass: "el-icon-delete-solid",
                                    on: {
                                      click: function($event) {
                                        return _vm.handleClickDeleteSelf(data)
                                      }
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "设置主管",
                                    placement: "top-start"
                                  }
                                },
                                [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.deptEditShow(data),
                                        expression: "deptEditShow(data)"
                                      }
                                    ],
                                    staticClass: "el-icon-s-custom",
                                    on: {
                                      click: function($event) {
                                        return _vm.setManagement(data)
                                      }
                                    }
                                  })
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: "上移",
                                    placement: "top-start"
                                  }
                                },
                                [
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.deptEditShow(data) &&
                                          node.level !== 1,
                                        expression:
                                          "deptEditShow(data) && node.level !== 1"
                                      }
                                    ],
                                    staticClass: "el-icon-top",
                                    on: {
                                      click: function($event) {
                                        return _vm.upSortFn(data)
                                      }
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "right-box" }, [
          _c(
            "div",
            { staticClass: "flex-sty com-ht" },
            [
              _c(
                "h1",
                {
                  staticClass: "com-title",
                  staticStyle: { "font-weight": "bold" }
                },
                [
                  _c("div", [
                    _c("i"),
                    _vm._v(
                      _vm._s(_vm.selectTreeNode.groupName) + "\n            "
                    )
                  ])
                ]
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 5 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "demo-form-inline",
                          attrs: {
                            inline: true,
                            model: _vm.filterModel,
                            size: "mini"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "140px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "姓名/邮箱/手机号"
                                },
                                model: {
                                  value: _vm.filterModel.targetId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filterModel, "targetId", $$v)
                                  },
                                  expression: "filterModel.targetId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100px" },
                                  attrs: { placeholder: "请选择状态" },
                                  model: {
                                    value: _vm.filterModel.inviteStatus,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filterModel,
                                        "inviteStatus",
                                        $$v
                                      )
                                    },
                                    expression: "filterModel.inviteStatus"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "全部状态", value: "" }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "已移除", value: -1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "正常", value: 1 }
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "待接受", value: 0 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "120px" },
                                  attrs: { placeholder: "请选择权限组" },
                                  model: {
                                    value: _vm.filterModel.corpRoleId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filterModel,
                                        "corpRoleId",
                                        $$v
                                      )
                                    },
                                    expression: "filterModel.corpRoleId"
                                  }
                                },
                                _vm._l(_vm.roles, function(v, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: v.label, value: v.value }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.filterSearch(1)
                                    }
                                  }
                                },
                                [_vm._v("查询")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticStyle: { "margin-right": "0" } },
                            [
                              _c("el-button", { on: { click: _vm.rest } }, [
                                _vm._v("重置")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { padding: "15px 20px" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: {
                            border: "1px solid #eeeeee",
                            "border-bottom": "0"
                          },
                          attrs: {
                            data: _vm.tableList,
                            "tooltip-effect": "dark",
                            "header-cell-style": {
                              background: "#f9f9f9",
                              color: "#333333",
                              fontWeight: "600"
                            }
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "成员信息",
                              "show-overflow-tooltip": "",
                              "min-width": "220"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "tr-overflow",
                                        attrs: {
                                          title:
                                            scope.row.userName +
                                            (scope.row.groupMan === 1
                                              ? "(主管)"
                                              : "")
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            class:
                                              scope.row.groupMan !== 1
                                                ? "ellipses-1-full"
                                                : "ellipses-1"
                                          },
                                          [
                                            scope.row.useStatus === -1 &&
                                            scope.row.inviteStatus === -1
                                              ? [
                                                  _c(
                                                    "span",
                                                    { staticClass: "delline" },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            scope.row.userName
                                                          ) +
                                                          "\n                          "
                                                      ),
                                                      _c("span")
                                                    ]
                                                  )
                                                ]
                                              : [
                                                  _vm._v(
                                                    _vm._s(scope.row.userName)
                                                  )
                                                ]
                                          ],
                                          2
                                        ),
                                        _c("div", {
                                          staticStyle: { clear: "both" }
                                        })
                                      ]
                                    ),
                                    _c("p", { staticClass: "tr-overflow" }, [
                                      _vm._v(
                                        "账号：" + _vm._s(scope.row.targetId)
                                      )
                                    ]),
                                    _c("p", { staticClass: "tr-overflow" }, [
                                      _vm._v(
                                        "部门：" + _vm._s(scope.row.groupNames)
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "状态",
                              prop: "useStatus",
                              width: "100"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.useStatus === -1 &&
                                    scope.row.inviteStatus === -1
                                      ? _c("p", [
                                          _c(
                                            "span",
                                            { staticClass: "dot-orange" },
                                            [_vm._v("●")]
                                          ),
                                          _vm._v(
                                            " 已移除\n                    "
                                          )
                                        ])
                                      : _vm._e(),
                                    scope.row.useStatus === 0
                                      ? _c("p", [
                                          _c(
                                            "span",
                                            { staticClass: "dot-green" },
                                            [_vm._v("●")]
                                          ),
                                          _vm._v(" 正常\n                    ")
                                        ])
                                      : _vm._e(),
                                    scope.row.useStatus === -1 &&
                                    scope.row.inviteStatus === 0
                                      ? _c("p", [
                                          _c(
                                            "span",
                                            { staticClass: "dot-red" },
                                            [_vm._v("●")]
                                          ),
                                          _vm._v(
                                            " 待接受\n                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "权限组及可管理部门",
                              "min-width": "300",
                              "show-overflow-tooltip": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._l(scope.row._roleNames, function(
                                      v,
                                      i
                                    ) {
                                      return _c("p", { key: i }, [
                                        _vm._v(_vm._s(v))
                                      ])
                                    }),
                                    !scope.row._roleNames.length
                                      ? _c("span", [_vm._v("默认查看权限")])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("el-table-column", {
                            attrs: { label: "操作", width: "130" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.useStatus === -1 &&
                                    scope.row.inviteStatus === 0
                                      ? _c(
                                          "p",
                                          {
                                            staticClass: "color-success",
                                            class: {
                                              "dis-sty": _vm.haveFlag(scope.row)
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleDel(scope.row)
                                              }
                                            }
                                          },
                                          [_vm._v("删除邀请")]
                                        )
                                      : _vm._e(),
                                    !(
                                      scope.row.useStatus === -1 &&
                                      scope.row.inviteStatus === -1
                                    )
                                      ? _c(
                                          "p",
                                          {
                                            staticClass: "color-success",
                                            class: {
                                              "dis-sty": _vm.haveFlag(scope.row)
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleClickAssign(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("分配权限")]
                                        )
                                      : _vm._e(),
                                    scope.row.useStatus === -1 &&
                                    scope.row.inviteStatus === -1
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "color-success pointer",
                                            class: {
                                              "dis-sty": _vm.haveFlag(scope.row)
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleClickBind(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("继承数据")]
                                        )
                                      : _vm._e(),
                                    scope.row.useStatus === -1 &&
                                    scope.row.inviteStatus === -1
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "color-success pointer",
                                            class: {
                                              "dis-sty": _vm.haveFlag(scope.row)
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.contractVisibleFn(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("合同交接")]
                                        )
                                      : scope.row.useStatus === -1 &&
                                        scope.row.inviteStatus === 0
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "color-success pointer",
                                            class: {
                                              "dis-sty": _vm.haveFlag(scope.row)
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleClickReinvite(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("重新邀请")]
                                        )
                                      : scope.row.useStatus === 0
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "color-success pointer",
                                            class: {
                                              "dis-sty": _vm.haveFlag(scope.row)
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleClickUnbind(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("移出组织")]
                                        )
                                      : _vm._e(),
                                    _vm.someFn(scope.row) &&
                                    scope.row.useStatus === 0
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "color-success pointer",
                                            class: {
                                              "dis-sty": _vm.haveFlag(scope.row)
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.moveOrg(scope.row)
                                              }
                                            }
                                          },
                                          [_vm._v("更换部门")]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _c("no-data", {
                            attrs: { slot: "empty", text: "暂无数据" },
                            slot: "empty"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "pageation" },
                [
                  _c(
                    "el-col",
                    {
                      staticClass: "page-flex-end",
                      staticStyle: { padding: "30px 0" },
                      attrs: { span: 24 }
                    },
                    [
                      _c("el-pagination", {
                        attrs: {
                          small: "",
                          "current-page": _vm.filterModel.itemPage,
                          "page-sizes": [10, 20, 50, 100],
                          "page-size": _vm.filterModel.pageSize,
                          layout: "sizes, prev, pager, next, total",
                          total: _vm.filterModel.pageTotal
                        },
                        on: {
                          "size-change": _vm.handleSizeChange,
                          "current-change": _vm.handleCurrentChange
                        }
                      }),
                      _c("el-go", {
                        attrs: {
                          "page-size": _vm.filterModel.pageSize,
                          total: _vm.filterModel.pageTotal
                        },
                        on: { "current-change": _vm.handleCurrentChange }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "继承数据",
            visible: _vm.visibleBindMember,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleBindMember = $event
            }
          }
        },
        [
          _c("i", {
            staticClass: "warn-img el-icon-warning",
            staticStyle: { "vertical-align": "top", "margin-top": "3px" }
          }),
          _c(
            "p",
            {
              staticStyle: {
                "font-size": "14px",
                "font-weight": "400",
                "line-height": "24px",
                color: "#290202",
                "margin-bottom": "20px",
                width: "95%",
                display: "inline-block"
              }
            },
            [
              _vm._v(
                "邀请新成员，并将当前已移出的成员的全部签署文件、权限组以及印章和模板继承给新加入的成员。"
              )
            ]
          ),
          _c(
            "el-form",
            {
              ref: "dialogModelBindMember",
              attrs: {
                rules: _vm.formAddMemberRules,
                "label-position": "right",
                "label-width": "80px",
                model: _vm.dialogModelBindMember
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "成员类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "mini", placeholder: "请选择" },
                      on: { change: _vm.handleChangeMemberType1 },
                      model: {
                        value: _vm.dialogModelBindMember.type,
                        callback: function($$v) {
                          _vm.$set(_vm.dialogModelBindMember, "type", $$v)
                        },
                        expression: "dialogModelBindMember.type"
                      }
                    },
                    [_c("el-option", { attrs: { label: "个人", value: 0 } })],
                    1
                  )
                ],
                1
              ),
              _vm.dialogModelBindMember.type === 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "手机号", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          maxlength: 11,
                          placeholder: "请输入手机号"
                        },
                        model: {
                          value: _vm.dialogModelBindMember.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.dialogModelBindMember, "phone", $$v)
                          },
                          expression: "dialogModelBindMember.phone"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogModelBindMember.type === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "邮箱", prop: "email" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          maxlength: 32,
                          placeholder: "请输入邮箱"
                        },
                        model: {
                          value: _vm.dialogModelBindMember.email,
                          callback: function($$v) {
                            _vm.$set(_vm.dialogModelBindMember, "email", $$v)
                          },
                          expression: "dialogModelBindMember.email"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogModelBindMember.type === 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          maxlength: 32,
                          placeholder: "请输入姓名"
                        },
                        model: {
                          value: _vm.dialogModelBindMember.name,
                          callback: function($$v) {
                            _vm.$set(_vm.dialogModelBindMember, "name", $$v)
                          },
                          expression: "dialogModelBindMember.name"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogModelBindMember.type === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "企业名称", prop: "enterpriseName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          maxlength: 32,
                          placeholder: "请输入企业名称"
                        },
                        model: {
                          value: _vm.dialogModelBindMember.enterpriseName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.dialogModelBindMember,
                              "enterpriseName",
                              $$v
                            )
                          },
                          expression: "dialogModelBindMember.enterpriseName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.visibleBindMember = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.bindMemberSubmit()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "重新邀请",
            visible: _vm.visibleReBindMember,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleReBindMember = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "dialogModelReBindMember",
              attrs: {
                rules: _vm.formAddMemberRules,
                "label-position": "right",
                "label-width": "80px",
                model: _vm.dialogModelReBindMember
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "成员类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { size: "mini", placeholder: "请选择" },
                      on: { change: _vm.handleChangeMemberType2 },
                      model: {
                        value: _vm.dialogModelReBindMember.type,
                        callback: function($$v) {
                          _vm.$set(_vm.dialogModelReBindMember, "type", $$v)
                        },
                        expression: "dialogModelReBindMember.type"
                      }
                    },
                    [_c("el-option", { attrs: { label: "个人", value: 0 } })],
                    1
                  )
                ],
                1
              ),
              _vm.dialogModelReBindMember.type === 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "手机号", prop: "phone" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          maxlength: 11,
                          placeholder: "请输入手机号"
                        },
                        model: {
                          value: _vm.dialogModelReBindMember.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.dialogModelReBindMember, "phone", $$v)
                          },
                          expression: "dialogModelReBindMember.phone"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogModelReBindMember.type === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "邮箱", prop: "email" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          maxlength: 32,
                          placeholder: "请输入邮箱"
                        },
                        model: {
                          value: _vm.dialogModelReBindMember.email,
                          callback: function($$v) {
                            _vm.$set(_vm.dialogModelReBindMember, "email", $$v)
                          },
                          expression: "dialogModelReBindMember.email"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogModelReBindMember.type === 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          maxlength: 32,
                          placeholder: "请输入姓名"
                        },
                        model: {
                          value: _vm.dialogModelReBindMember.name,
                          callback: function($$v) {
                            _vm.$set(_vm.dialogModelReBindMember, "name", $$v)
                          },
                          expression: "dialogModelReBindMember.name"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.dialogModelReBindMember.type === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "企业名称", prop: "enterpriseName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          maxlength: 32,
                          placeholder: "请输入企业名称"
                        },
                        model: {
                          value: _vm.dialogModelReBindMember.enterpriseName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.dialogModelReBindMember,
                              "enterpriseName",
                              $$v
                            )
                          },
                          expression: "dialogModelReBindMember.enterpriseName"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.visibleReBindMember = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.rebindMemberSubmit()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("add-member", {
        attrs: { show: _vm.visibleAddMember, callback: _vm.queryTool },
        on: {
          "update:show": function($event) {
            _vm.visibleAddMember = $event
          },
          refresh: _vm.initTreeGroup
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择调整组织",
            visible: _vm.visibleMoveOrg,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.visibleMoveOrg = $event
            }
          }
        },
        [
          _c("el-tree", {
            ref: "referenceMoveTree",
            staticClass: "tree-style",
            attrs: {
              data: _vm.treeGroupCopy,
              "highlight-current": true,
              "default-expand-all": true,
              "expand-on-click-node": false,
              "filter-node-method": function(value, data) {
                return data.editFlag !== 0
              },
              "node-key": "corpGroupId",
              props: _vm.defaultProps
            },
            on: { "node-click": _vm.handleNodeClickMove }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.visibleMoveOrg = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.moveOrgSubmit()
                    }
                  }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "custom-table com-dialog",
          attrs: {
            width: "50%",
            top: "10vh",
            title: "分配权限",
            visible: _vm.showDistribute
          },
          on: {
            "update:visible": function($event) {
              _vm.showDistribute = $event
            },
            close: function($event) {
              return _vm.clearSelection("roleSelection")
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _vm.creatRoleVisibleBtn
                ? _c(
                    "p",
                    { staticClass: "my-title" },
                    [
                      _c("span", [
                        _c("img", {
                          attrs: { src: "/images/web/icon-shou.png" }
                        }),
                        _vm._v(
                          "选择下列权限组赋给成员，则可以使用系统相应的功能，也可以新建一个权限组赋给成员\n          "
                        )
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.createdRoleGroup }
                        },
                        [_vm._v("创建权限组")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  ref: "roleSelection",
                  attrs: {
                    "max-height": "400px",
                    data: _vm.distributeRoles,
                    "default-sort": { prop: "corpRoleId", order: "ascending" },
                    border: ""
                  },
                  on: {
                    select: _vm.selectedChange,
                    "selection-change": _vm.distributeRoleSelect
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", "max-width": "55" }
                  }),
                  _c("el-table-column", {
                    attrs: { property: "groupName", label: "需要管理的部门" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("p", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    scope.row.groupName ||
                                      _vm.distibuteInfo.groupNames
                                  ) +
                                  "\n                "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "color-success",
                                  staticStyle: {
                                    "margin-right": "10px",
                                    cursor: "pointer"
                                  },
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function($event) {
                                      return _vm.chooseAuth(
                                        scope.row,
                                        scope.$index
                                      )
                                    }
                                  }
                                },
                                [_vm._v("修改")]
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "roleName",
                      label: "权限组名称",
                      "max-width": "200"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      property: "remark",
                      label: "权限组描述",
                      "max-width": "200"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "权限组操作", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "color-success",
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-right": "10px"
                                  },
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editRole(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("查看")]
                              )
                            ]
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.showDistribute = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.doDistribute }
                },
                [_vm._v("确定")]
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "选择权限范围",
                visible: _vm.showChooseAuth,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.showChooseAuth = $event
                }
              }
            },
            [
              _c("el-tree", {
                ref: "treeRef",
                attrs: {
                  data: _vm.treeGroup,
                  "node-key": "corpGroupId",
                  "default-expanded-keys": _vm.treeGroupKeys,
                  "highlight-current": true,
                  props: _vm.defaultProps
                },
                on: { "node-click": _vm.checkGroup }
              }),
              _c(
                "el-row",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.showChooseAuth = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.doChooseAuth }
                    },
                    [_vm._v("确定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.dialogVisi
        ? _c("role-form", {
            attrs: {
              diaTitle: _vm.diaTitle,
              rowInfo: _vm.rowInfo,
              viewDetail: true,
              distributeRoles: _vm.distributeRoles
            },
            on: { closePup: _vm.closePup, getRoles: _vm.susChange }
          })
        : _vm._e(),
      _c("join-apply", {
        attrs: { joinApplyVisi: _vm.joinApplyVisi },
        on: {
          "update:joinApplyVisi": function($event) {
            _vm.joinApplyVisi = $event
          },
          "update:join-apply-visi": function($event) {
            _vm.joinApplyVisi = $event
          },
          refresh: _vm.getApplyList
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: { title: "合同数据交接", visible: _vm.contractSendVisible },
          on: {
            "update:visible": function($event) {
              _vm.contractSendVisible = $event
            }
          }
        },
        [
          [
            _c("p", { staticStyle: { "border-bottom": "1px solid #f0f0f0" } }, [
              _vm._v("将当前已移出的成员的合同数据抄送给所选择的成员。")
            ]),
            _c(
              "div",
              { staticStyle: { "text-align": "right" } },
              [
                _c("el-input", {
                  staticStyle: { width: "300px", "margin-right": "10px" },
                  attrs: { size: "small", placeholder: "请输入姓名" },
                  model: {
                    value: _vm.filterModelNew.targetId,
                    callback: function($$v) {
                      _vm.$set(_vm.filterModelNew, "targetId", $$v)
                    },
                    expression: "filterModelNew.targetId"
                  }
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.contractSendUserListFn }
                  },
                  [_vm._v("搜索")]
                )
              ],
              1
            ),
            _c(
              "ul",
              _vm._l(_vm.contractSendUserList, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: [
                      "contract_li",
                      { active: item.corpUserId === _vm.contractSendActive }
                    ],
                    on: {
                      click: function($event) {
                        _vm.contractSendActive = item.corpUserId
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(item.userName) +
                        "（账号：" +
                        _vm._s(item.targetId) +
                        "）\n          "
                    )
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              {
                staticClass: "page-flex-end",
                staticStyle: { position: "relative", padding: "30px 0 0 0" }
              },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.filterModelNew.itemPage,
                    "page-sizes": [10, 20, 50, 100],
                    "page-size": _vm.filterModelNew.pageSize,
                    layout: "sizes, prev, pager, next, total",
                    total: _vm.filterModelNew.pageTotal
                  },
                  on: {
                    "size-change": _vm.handleSizeChangeNew,
                    "current-change": _vm.handleCurrentChangeNew
                  }
                }),
                _c("el-go", {
                  attrs: {
                    "page-size": _vm.filterModelNew.pageSize,
                    total: _vm.filterModelNew.pageTotal
                  },
                  on: { "current-change": _vm.handleCurrentChangeNew }
                })
              ],
              1
            )
          ],
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function($event) {
                      _vm.contractSendVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.contractSendFn }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        2
      ),
      _c("add-child-pup", {
        attrs: {
          visibleDialogTitle: _vm.visibleDialogTitle,
          visibleDialog: _vm.visibleDialog,
          superDeptsTree: _vm.superDeptsTree,
          pupModel: _vm.modelDialog,
          isEdit: _vm.isEdit
        },
        on: {
          "update:visibleDialog": function($event) {
            _vm.visibleDialog = $event
          },
          "update:visible-dialog": function($event) {
            _vm.visibleDialog = $event
          },
          refresh: _vm.refresh
        }
      }),
      _c("supervisor", {
        attrs: {
          visibleDialogSetManager: _vm.visibleDialogSetManager,
          selectCorpGroupId: _vm.selectTreeNode.corpGroupId
        },
        on: {
          "update:visibleDialogSetManager": function($event) {
            _vm.visibleDialogSetManager = $event
          },
          "update:visible-dialog-set-manager": function($event) {
            _vm.visibleDialogSetManager = $event
          },
          refresh: _vm.refresh
        }
      }),
      _c("sync-organ-pup", {
        attrs: {
          center: "",
          title: "组织架构同步配置",
          orgSyncType: _vm.orgSyncType,
          visible: _vm.orgSyncVisi,
          width: "40%"
        },
        on: {
          "update:visible": function($event) {
            _vm.orgSyncVisi = $event
          },
          close: _vm.closeSyncDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a81b916c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a81b916c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/console/memberManage/memberCom.vue
// module id = v1H9
// module chunks = 7 40